import { AUTH_ROUTES } from "../components/authRoutes";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../homeDashboard/HomeDashboardSidebar";
import Header from "../homeDashboard/HomeDashboardHeader";
import HomeDashboardFooter from "../homeDashboard/HomeDashboardFooter";
import "../layout/Layout.css";
import "../homeDashboard/HomeDashboardSidebar.css";
import LogoutPopup from "../settingProfile/LogoutPopup";
import { useAuth } from "../context/AuthContext";
import { useSidebarData } from "../hooks/useSidebarData";

const Layout = ({ children, showHeader = true, dashboardHeaderData = null, variant = "" }) => {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 1200);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();
  const {
    data: sidebarData = null,
    isLoading: sidebarLoading,
    isError: hasSidebarError,
    error: sidebarQueryError,
  } = useSidebarData();

  const sidebarError = hasSidebarError
    ? sidebarQueryError?.response?.data?.message || sidebarQueryError?.message || "Unable to load sidebar data."
    : "";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);

    try {
      await logout();
      setShowLogoutModal(false);
      navigate(AUTH_ROUTES.signIn, { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className={`layout-wrapper homeDashboard-wrapper${variant ? ` ${variant}` : ""}`}>
      <Sidebar
        isOpen={sidebarOpen}
        onLogoutClick={() => setShowLogoutModal(true)}
        sidebarData={sidebarData}
        sidebarError={sidebarError}
        sidebarLoading={sidebarLoading}
        onClose={() => setSidebarOpen(false)}
      />
      {sidebarOpen && window.innerWidth < 1200 && (
        <div className="overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <div className={`main-content ${sidebarOpen ? "shifted" : ""}`}>
        {showHeader && (
          <Header
            toggleSidebar={() => setSidebarOpen((prev) => !prev)}
            isSidebarOpen={sidebarOpen}
            sidebarData={sidebarData}
            dashboardHeaderData={dashboardHeaderData}
          />
        )}
        <div className="page-content">{typeof children === "function"
          ? children({ toggleSidebar: () => setSidebarOpen((prev) => !prev), isSidebarOpen: sidebarOpen })
          : children}</div>
      </div>

      <LogoutPopup
        open={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
        isLoading={isLoggingOut}
      />

      <HomeDashboardFooter />
    </div>
  );
};

export default Layout;
